import React, { FC } from 'react';
import TimeDisplay from '@components/common/TimeDisplay';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';

interface ShortTimeDisplayProps {
  targetDuration: number;
  color: string;
  C: ColorFunction;
}

const ShortTimeDisplay: FC<ShortTimeDisplayProps> = ({ targetDuration, color, C }) => {
  return (
    <TimeDisplay
      value={targetDuration}
      color={color}
      C={C}
      fontForDigit="Time 2"
      fontForLetter="Footnote"
      fontForSecondDigit="Time 4"
      fontForSecondLetter="Caption 2"
    />
  );
};

export default ColorWrapper(ShortTimeDisplay);
